import { Component, ChangeDetectionStrategy, input } from '@angular/core';

@Component({
  selector: 'lib-tm-logo',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <svg
      [attr.width]="width()"
      [attr.height]="height()"
      viewBox="0 0 42 21"
      fill="none"
      [class]="iconClass()"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M-1.74344e-06 3.54973V1.04904e-05H16.7244V3.54973H10.4901V20.3636H6.23437V3.54973H-1.74344e-06ZM19.4787 1.04904e-05H24.7884L30.3963 13.6818H30.6349L36.2429 1.04904e-05H41.5526V20.3636H37.3764V7.10939H37.2074L31.9375 20.2642H29.0937L23.8239 7.05967H23.6548V20.3636H19.4787V1.04904e-05Z"
        fill="#2970FF" />
    </svg>
  `,
})
export class TmLogoComponent {
  width = input<string>('42');
  height = input<string>('21');
  iconClass = input<string>('');
}
